import { createContext, useContext } from 'react';

export const MppContext = createContext({
  data: null,
  loading: false,
  error: null,
  refreshData: () => {},
  lastUpdated: null,
  uploadInProgress: false
});

export const useMppContext = () => {
  const context = useContext(MppContext);
  if (!context) {
    throw new Error('useMppContext must be used within a MppContextProvider');
  }
  return context;
};